import { Column, Entity, Index } from 'typeorm';
import type { BoothBlockSource } from '../../constants/booking';
import { BaseEntity } from './base.entity';

/**
 * PD-17649 — when people can book a show's booth, by show day. A day starts from the
 * show's trade show hours; `source` says whether it still follows them. `showStartMinute`
 * and `showEndMinute` are the organizer's hours the block was last based on, so a later
 * change to them can be noticed. Minutes are from midnight in the show's time zone.
 */
@Index('IDX_trade_show_booking_block_show', ['fkTradeShowId', 'blockDate'])
@Entity('trade_show_booking_block')
export class TradeShowBookingBlockEntity extends BaseEntity {
	@Column('int', { name: 'fk_trade_show__id', unsigned: true })
	public fkTradeShowId!: number;

	@Column('date', { name: 'blockDate' })
	public blockDate!: string;

	@Column('int', { name: 'startMinute', unsigned: true })
	public startMinute!: number;

	@Column('int', { name: 'endMinute', unsigned: true })
	public endMinute!: number;

	@Column('varchar', { name: 'place', length: 255, nullable: true })
	public place!: string | null;

	/** How many meetings can run at once; the tables on the grid. */
	@Column('int', { name: 'atOnce', unsigned: true, default: 1 })
	public atOnce!: number;

	@Column('varchar', { name: 'source', length: 16 })
	public source!: BoothBlockSource;

	/** A show day turned off keeps its row, so turning it back on restores it. */
	@Column({ type: 'boolean', name: 'isOff', width: 1, default: () => "'0'" })
	public isOff!: boolean;

	@Column('int', { name: 'showStartMinute', unsigned: true, nullable: true })
	public showStartMinute!: number | null;

	@Column('int', { name: 'showEndMinute', unsigned: true, nullable: true })
	public showEndMinute!: number | null;

	/** The organizer's hours changed on a day we changed: "The show now opens at 11:30 AM". */
	@Column('varchar', { name: 'changeNote', length: 255, nullable: true })
	public changeNote!: string | null;
}
